import classNames from 'classnames'
import './card.less'
import React from 'react'

const WidgetCard: React.FC<
  React.HTMLProps<HTMLDivElement> & {
    cardTitle?: React.ReactNode
    cardTitleClassName?: string
    cardFooter?: React.ReactNode
    collapsed?: boolean
  }
> = ({ cardTitle, cardTitleClassName = '', cardFooter, children, collapsed = false, ...rest }) => {
  const propsWithMergedClassNames = { ...rest, className: `card ${rest?.className || ''}` }
  return (
    <div {...propsWithMergedClassNames}>
      {cardTitle && (
        <div className={classNames('card-title', { [cardTitleClassName]: cardTitleClassName })}>
          {cardTitle}
        </div>
      )}
      {!collapsed && <div className="card-body">{children}</div>}
      {cardFooter && <div className="widget-card-footer">{cardFooter}</div>}
    </div>
  )
}

export default WidgetCard
